import { Component, OnDestroy, OnInit } from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { filter, takeUntil } from 'rxjs/operators';
import { UtilsService } from '../../services/utils.service';
import {
  ROOT_ENTITY_ID_QUERY_PARAM_NAME,
  ROOT_ENTITY_TITLE,
  RootEntityService,
} from '../root-entity.service';
import { RootEntity } from '@shared/models/root-entity';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

import { sleep } from '@shared/utils/helpers';

@Component({
  selector: 'app-root-entities-switcher',
  template: `
    @if (options.length > 1) {
      <p-select
        class="dropdown"
        [options]="options"
        optionLabel="name"
        [filter]="true"
        [ngModel]="selected"
        (onChange)="handleSelectedChange($event.value)"
        placeholder="Choose organization"
      >
      </p-select>
    }
    @if (options.length === 1) {
      <p class="root-entity-name">
        {{ options[0].name }}
      </p>
    }
  `,
  styleUrls: ['./root-entities-switcher.component.scss'],
  imports: [SelectModule, FormsModule],
})
export class RootEntitiesSwitcherComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  selected: RootEntity = null;
  options: RootEntity[] = [];

  constructor(
    private rootEntityService: RootEntityService,
    private notificationService: NotificationService,
    private utilsService: UtilsService,
  ) {}

  async ngOnInit() {
    const availableRows = await firstValueFrom(this.rootEntityService.rootEntities$);

    if (availableRows.length === 0) {
      this.notificationService.showError(
        `You haven't access to any ${ROOT_ENTITY_TITLE} in the system. Please, create ${ROOT_ENTITY_TITLE} or ask project administrator to share access to the ${ROOT_ENTITY_TITLE} to you.`,
      );
    }

    this.rootEntityService.rootEntities$
      .pipe(
        takeUntil(this.destroy$),
        filter((rootEntities) => rootEntities.length > 0),
      )
      .subscribe((rootEntities) => {
        this.options = rootEntities;
        const selectedRow = this.rootEntityService.currentRootEntity$.getValue();
        this.selected = this.options.find((org) => org.id === selectedRow?.id);
      });
  }

  async handleSelectedChange(rootEntity: RootEntity) {
    this.rootEntityService.setRootEntity(rootEntity);
    this.selected = rootEntity;

    // Extra delay to update firestore data before reloading page to have right data after reload
    // Not ideal solution, but it works. This time might be not enough for loading data in some cases
    await sleep(500);
    await this.utilsService.reloadPage({
      [ROOT_ENTITY_ID_QUERY_PARAM_NAME]: rootEntity.id,
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
